import 'css-chunk:src/utils/ErrorBoundary/ErrorTrace.scss';export default {
  "ErrorTrace": "_ErrorTrace_1x3to_1"
};